exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header-info[data-v-0ebcd052] {\n    border-right: 1px solid rgba(250, 250, 250, 0.1);\n}\n@media only screen and (max-width: 960px) {\n.header-info[data-v-0ebcd052] {\n        border-top: 1px solid rgba(250, 250, 250, 0.1);\n        border-right: none;\n}\n.header-info2[data-v-0ebcd052] {\n        border-top: 1px solid rgba(250, 250, 250, 0.1);\n}\n}\n", ""]);

// exports
